import {
  AuthFormValues,
  AuthMode,
  AuthModeEnum,
  ValidationErrors,
} from "./types";

export function validateAuthFields(
  values: AuthFormValues,
  mode: AuthMode
): ValidationErrors {
  const errors: ValidationErrors = {};

  if (
    mode !== AuthModeEnum.RESET &&
    mode !== AuthModeEnum.EDIT_PROFILE &&
    mode !== AuthModeEnum.CODE
  ) {
    if (!values.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      errors.email = "Введіть коректний email.";
    }
  }

  if (
    [AuthModeEnum.LOGIN, AuthModeEnum.REGISTER, AuthModeEnum.RESET].includes(
      mode
    )
  ) {
    if (!values.password || values.password.length < 6) {
      errors.password = "Пароль має містити щонайменше 6 символів.";
    }
  }

  if ([AuthModeEnum.REGISTER, AuthModeEnum.RESET].includes(mode)) {
    if (!values.confirmPassword || values.password !== values.confirmPassword) {
      errors.confirmPassword = "Паролі не співпадають.";
    }
  }

  if ([AuthModeEnum.REGISTER, AuthModeEnum.EDIT_PROFILE].includes(mode)) {
    if (!values.firstName || values.firstName.trim() === "") {
      errors.firstName = "Введіть ім’я.";
    }

    if (!values.lastName || values.lastName.trim() === "") {
      errors.lastName = "Введіть прізвище.";
    }

    if (!values.phone || !/^\+?\d{12}$/.test(values.phone)) {
      errors.phone = "Введіть коректний номер телефону.";
    }
  }

  if (mode === AuthModeEnum.CODE) {
    if (
      !values.code ||
      values.code.length !== 4 ||
      !/^\d{4}$/.test(values.code)
    ) {
      errors.code = "Перевірте чи коректно введений код.";
    }
  }

  return errors;
}
